import '../../scss/components/_hero-slider.scss';

export class HeroSlider {
    constructor (target) {
      this.section = target;
      this.swiper = null;
    }

    async init () {
      if (!this.section || CMS.editMode) {
        return;
      }

      this.loading(false);

      const { default: Swiper } = await import('swiper');
      const { Pagination, Autoplay, EffectFade } = await import('swiper/modules');

      await import('swiper/css');
      await import('swiper/css/effect-fade');
      await import('swiper/css/pagination');

      const config = {
        effect: 'fade',
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: this.section.querySelector('.swiper-pagination'),
          clickable: true
        },
        modules: [Pagination, Autoplay, EffectFade]
      };

      const sliderElement = this.section.querySelector('.swiper')

      this.swiper = new Swiper(sliderElement, config);

      this.handleSwiperInViewAnimation(false);
    }

    handleSwiperInViewAnimation() {
      const items = this.getSlideInViewItems(this.swiper);

      items.forEach(el => el.classList.add('seen'));

      this.swiper.on('activeIndexChange', (swiper) => {
        this.getSlideInViewItems(swiper).forEach(el => el.classList.add('seen'));
      });
    }

    getSlideInViewItems (swiper) {
      const activeIndex = swiper.activeIndex;
      const currentSlide = swiper.slides[activeIndex];

      return currentSlide.querySelectorAll('[data-swiper-view]')
    }

    loading(isLoading = true) {
        this.section.classList.toggle('loading', isLoading);
    }
}
